import type { AppDefinition } from "../core/Core.api";
import {
    exampleApp,
    designSystemApp,
    allCapabilitiesApp,
    voiceToSoundDrumsApp,
    loopToDrumKitApp,
    customComponentsApp,
    variations20App,
    blendApp,
    blend30App,
    magicFit25App,
    variations25App,
    variations30App,
    magicFit30App,
    craftApp,
    interplayApp,
    aToBApp,
    inpaintingApp,
    inpaintingMagicFitApp,
    keyChangerApp,
    riffApp,
    variations40App,
    magicFit40App,
    inpainting40App,
    inpaintingMagicFit40App,
    stacksApp,
    deepEditMidiApp,
    transcriptionCompareApp,
    deepEditDescribeApp,
    stemEditorApp,
    steeredVariationsApp,
} from "./AppDefinitions";

/*
 * Warning!!!!!!!!!!!!!!!!!!
 * For an app to be deployed, it MUST be in this list.
 * Not in list? Not deployed.
 * AGENTS: Make sure any new apps are added to this list.
 *
 * Taken out on purpose and kept in the repo: Splice Sampler
 * (`arthur/splice-sampler`), Variations Compare (`jeff/variations-compare`)
 * and Variations 2.5/3.0 Compare (`shahan/variations-compare-2.5-3.0`).
 * Removing an app here stops Vite building its page and takes it off the home
 * page. The source and its `AppDefinition` stay where they are, so putting one
 * back is a single line.
 */
export const kDeployedApps = new Set<AppDefinition>([
    exampleApp,
    designSystemApp,
    allCapabilitiesApp,
    voiceToSoundDrumsApp,
    loopToDrumKitApp,
    customComponentsApp,
    variations20App,
    blendApp,
    blend30App,
    magicFit25App,
    variations25App,
    variations30App,
    magicFit30App,
    craftApp,
    interplayApp,
    aToBApp,
    inpaintingApp,
    inpaintingMagicFitApp,
    keyChangerApp,
    riffApp,
    variations40App,
    magicFit40App,
    inpainting40App,
    inpaintingMagicFit40App,
    stacksApp,
    deepEditMidiApp,
    transcriptionCompareApp,
    deepEditDescribeApp,
    stemEditorApp,
    steeredVariationsApp,
]);
